<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
        <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
          <span class="fa fa-question-circle"></span>
        </el-tooltip>
        <el-input
          :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
          :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
          :value="value"
          @input="phoneInput"
          @change="executeFunctions('blur')"
          :title="value"
          :disabled="disabled || component.properties.readonly"
          :required="component.properties.required"
          :placeholder="component.properties.placeholder"
          @focus="inputFocus(component, index)"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'

export default {
  name: 'rc-phone',
  mixins: [ componentMixin, inputMixin ],
  props: {
    component: Object,
    value: {
      default: ''
    },
    disabled: Boolean,
    labelParameter: Object,
    index: [Number, String],
    tableCtrlKey: Boolean
  },
  data () {
    return {
      rules: this.buildRule()
    }
  },
  methods: {
    phoneInput (value) {
      this.update(value)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-phone.vue